import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  CircularProgress
} from '@mui/material';
import {
  Schedule as ScheduleIcon,
  Assignment as BillIcon,
  Payment as PayrollIcon,
  TrendingUp as ReportsIcon
} from '@mui/icons-material';
import PageLayout from '@/components/Layout/PageLayout';

const BillingMainPage: React.FC = () => {
  const navigate = useNavigate();

  // Redirect to billing periods by default
  useEffect(() => {
    navigate('/billing/periods', { replace: true });
  }, [navigate]);

  return (
    <PageLayout>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
      <CircularProgress />
    </Box>
    </PageLayout>
  );
};

export default BillingMainPage;